import i18n from "config/i18n"
import { SelectOptionType } from "types"

export function smartIdCountryOptions(): SelectOptionType[] {
  return ["ee", "lv", "lt"].map((code: string) => {
    return { label: i18n.t(`countries.${code}.title`), value: code }
  })
}

export function geocodingCountryOptions(): SelectOptionType[] {
  // NOTE: options with google maps geocoding ["ee", "lv", "lt", "fi", "other"]
  // regio only options ["ee", "lv", "lt"]
  return ["ee", "lv", "lt"].map((code: string) => {
    return { label: i18n.t(`countries.${code}.title`), value: code }
  })
}

export function mobilePhoneCountryOptions(): SelectOptionType[] {
  return ["372", "371", "370", "358"].map((code: string) => {
    return { label: `+${code}`, value: code }
  })
}
